export const BlueLines = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path
        d="M0.898438 4.5H17.0984M0.898438 8.1H17.0984M0.898438 11.7H17.0984M0.898438 15.3H13.4984"
        stroke="#155EEF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
